/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Landing_Community_Mock_ToggleInputs */

const tr_landing_community_mock_toggle = /** @type {(inputs: Landing_Community_Mock_ToggleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`sohbet açık`)
};

const en_landing_community_mock_toggle = /** @type {(inputs: Landing_Community_Mock_ToggleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`chat on`)
};

const de_landing_community_mock_toggle = /** @type {(inputs: Landing_Community_Mock_ToggleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Chat an`)
};

const ru_landing_community_mock_toggle = /** @type {(inputs: Landing_Community_Mock_ToggleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`чат включён`)
};

/**
* | output |
* | --- |
* | "chat on" |
*
* @param {Landing_Community_Mock_ToggleInputs} inputs
* @param {{ locale?: "tr" | "en" | "de" | "ru" }} options
* @returns {LocalizedString}
*/
export const landing_community_mock_toggle = /** @type {((inputs?: Landing_Community_Mock_ToggleInputs, options?: { locale?: "tr" | "en" | "de" | "ru" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Landing_Community_Mock_ToggleInputs, { locale?: "tr" | "en" | "de" | "ru" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_landing_community_mock_toggle(inputs)
	if (locale === "de") return de_landing_community_mock_toggle(inputs)
	if (locale === "ru") return ru_landing_community_mock_toggle(inputs)
	return tr_landing_community_mock_toggle(inputs)
});